module.exports = __webpack_public_path__ + "static/media/google-chrome.4e990495.jfif";